import React from 'react';

import { Button } from '@/components/global/Button';

import { TComponentCard } from '@/services/requests/Recommendation/types/template5';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

export const CardUnLogged = ({
  card,
  index,
}: {
  card: TComponentCard;
  index: number;
}) => {
  const { title, icon_title, cta } = card;

  const handleClick = () => {
    if (cta.link) {
      window.location.href = cta.link;
    }
  };
  if (!title && !icon_title) {
    return null;
  }
  return (
    <div
      className="vitrine-template5__vouchers_carrousel__card vitrine-template5__vouchers_carrousel__card--unlogged"
      data-id={`${index}-${card.voucher_number}`}
    >
      <span className="icon">
        <img src={icon_title} alt={clearHtmlTags(title)} />
      </span>
      <span className="title">{title}</span>
      {cta.label && <Button text={cta.label} onClick={handleClick} isPill />}
    </div>
  );
};
